export default function initCard() {
  const openedClass = 'opened';
  let prevCard = null;

  document.querySelectorAll('.card').forEach((card) => {
    const opener = card.querySelector('.card-opener');

    if (!opener) return;

    opener.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (prevCard && prevCard !== card) {
        prevCard.classList.remove(openedClass);
      }

      card.classList.toggle(openedClass);
      prevCard = card.classList.contains(openedClass) ? card : null;
    });
  });

  document.addEventListener(
    'click',
    (e) => {
      if (prevCard && !e.target.closest('.card')) {
        prevCard.classList.remove(openedClass);
        prevCard = null;
      }
    },
    true
  );

  document.querySelectorAll('.card-slider').forEach((holder) => {
    const slides = holder.querySelectorAll('.card-slide');
    const scrollContainer = holder.querySelector('.overflow-auto');
    const prevBtn = holder.querySelector('.btn-prev');
    const nextBtn = holder.querySelector('.btn-next');
    let currentIndex = Array.from(slides).findIndex((slide) => slide.classList.contains('opened'));
    if (currentIndex === -1) currentIndex = 0;

    holder.style.setProperty('--items', slides.length);

    function updateButtons() {
      if (prevBtn) {
        prevBtn.classList.toggle('disabled', currentIndex === 0);
      }
      if (nextBtn) {
        nextBtn.classList.toggle('disabled', currentIndex === slides.length - 1);
      }
    }

    function openSlide(index) {
      if (index < 0 || index >= slides.length) return;

      slides.forEach((slide, i) => {
        slide.classList.toggle('opened', i === index);
      });

      currentIndex = index;
      updateButtons();

      if (scrollContainer && window.innerWidth < 768) {
        setTimeout(() => {
          const target = slides[index];
          const scrollOffset = target.offsetLeft - scrollContainer.offsetLeft;
          scrollContainer.scrollTo({
            left: scrollOffset,
            behavior: 'smooth',
          });
        }, 500);
      }
    }

    slides.forEach((slide, index) => {
      slide.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openSlide(index);
      });
    });

    prevBtn &&
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentIndex > 0) {
          openSlide(currentIndex - 1);
        }
      });

    nextBtn &&
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentIndex < slides.length - 1) {
          openSlide(currentIndex + 1);
        }
      });

    openSlide(currentIndex);
  });
}
